<template>
  <div>
    <app-header></app-header>
    <div class="container-fluid" style="background-color: white;">
      <div class="display-4">Cilinders Online</div>
      <hr>
    </div>

    <div class="container-fluid">
      <button class="btn btn-primary mb-2" @click="config880" style="width: 300px; height: 200px"><img class="centered-and-cropped mb-2" :src="'/src/assets/880cyl.PNG'" height = "100 " width= "200"><h4>880-reeks</h4><p>sleutelbediend</p></button>
      <button class="btn btn-primary mb-2" style="width: 300px; height: 200px"><img class="centered-and-cropped mb-2" :src="'/src/assets/881.PNG'" height = "100 " width= "200"><h4>881-reeks</h4><p>1 zijde sleutel, 1 zijde knop Type 1</p></button>
      <button class="btn btn-primary mb-2" style="width: 300px; height: 200px"><img class="centered-and-cropped mb-2" :src="'/src/assets/882.PNG'" height = "100 " width= "200"><h4>882-reeks</h4><p>1 zijde sleutel, 1 zijde knop Type 2</p></button>
      <button class="btn btn-primary mb-2" style="width: 300px; height: 200px"><img class="centered-and-cropped mb-2" :src="'/src/assets/883.PNG'" height = "100 " width= "200"><h4>883-reeks</h4><p>1 zijde sleutel, 1 zijde knop Type 3</p></button>
      <button class="btn btn-primary mb-2" style="width: 300px; height: 200px"><img class="centered-and-cropped mb-2" :src="'/src/assets/880-10.PNG'" height = "100 " width= "200"><h4>880-10-reeks</h4><p>halve cilinders</p></button>
    </div>
  </div>
</template>

<script>
import AppHeader from "../intro/AppHeader";
import store from '../../ClientApp/store';
import projectsteps from '../../ClientApp/helpers/project-steps';

export default {
  methods: {
    config880(){
      this.$router.push('/config880');
    }
  }
}
</script>

<style scoped>
    @media (min-width: 1500px) {
        .container-fluid {
        width: 80%;
        }
    }
    @media (min-width: 2000px) {
        .container-fluid {
        width: 60%;
        }
    }
    .lnk{
      cursor:pointer;
    }

    .centered-and-cropped { object-fit: contain }
    
</style>


// WEBPACK FOOTER //
// src/components/cilinders/Cilinder880.vue